export default __webpack_public_path__ + "static/media/servicio-hospedaje-exclusivo.0c76b5d4.jpg";